export enum U21AiChatBubbleType {
  BUTTON = 'button',
  MULTISELECT = 'multiselect',
  SINGLESELECT = 'singleselect',
}

export const MAX_AI_CHAT_CHOICES = 5;

export interface U21AiChatBubbleInnerProps {
  choices: string[];
  disabled?: boolean;
}

export interface U21AiChatButtonInnerProps extends U21AiChatBubbleInnerProps {
  onSubmit: (answer: string) => void;
}

export interface U21AiChatMultiSelectInnerProps extends U21AiChatBubbleInnerProps {
  initialValues?: string[];
  onSubmit: (answer: string[]) => void;
}

export interface U21AiChatSingleSelectInnerProps extends U21AiChatBubbleInnerProps {
  initialValues?: string;
  onSubmit: (answer: string) => void;
}
